import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ReducerStateType } from './types';

const initialState = {
  offset: 0,
  limit: 25,
  search: '',
  order: 'desc',
  sortBy: 'startDate',
  clearPage: true
} as ReducerStateType;

export const dealListingSlice = createSlice({
  name: 'dealListing',
  initialState,
  reducers: {
    resetDealListingValues: state => ({
      ...state,
      offset: 0,
      limit: 25,
      search: '',
      order: 'desc',
      sortBy: 'startDate'
    }),
    updateDealListingValues: (state, { payload }) => ({
      ...state,
      ...payload
    }),
    updateDealListingClearPage: (
      state,
      { payload }: PayloadAction<boolean>
    ) => ({
      ...state,
      clearPage: payload
    })
  }
});

export const {
  resetDealListingValues,
  updateDealListingValues,
  updateDealListingClearPage
} = dealListingSlice.actions;

export default dealListingSlice.reducer;
